import { useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';

import quotation from 'src/repositories/quotation';
import { API_KEY } from 'src/constants/apiKey';
import { productFormat } from 'src/utils/product';
import { STATUS_CODE } from 'src/constants/app';
import { t } from 'src/libs/i18n';
import _ from 'lodash';

type UseManufacturingSizeOptions = {
  enabled?: boolean;
};

const useMultipleManufacturingSize = (
  id,
  productCd,
  machiningMethod,
  setEstimateErrors,
  isProductFinished,
  processReEstimateSizes,
  options: UseManufacturingSizeOptions = {},
) => {
  const productSplit = productFormat.splitProductId(productCd);
  const canFetch =
    !isProductFinished &&
    Boolean(
      productSplit?.hakudoShhnCd ||
        productSplit?.shhnCd ||
        productSplit?.api1ShhnCd ||
        productSplit?.api2ShhnCd,
    );
  const enabled =
    options.enabled === undefined ? canFetch : options.enabled && canFetch;

  const { ...rest } = useQuery<
    AxiosResponse<Response.ManufacturingSize>,
    AxiosError<any>
  >(
    [
      API_KEY.MANUFACTURING_SIZES,
      {
        id,
        hakudoShhnCd: productSplit?.hakudoShhnCd,
        shhnCd: productSplit?.shhnCd,
        kakoCd: machiningMethod,
        api1ShhnCd: productSplit?.api1ShhnCd,
        api2ShhnCd: productSplit?.api2ShhnCd,
      },
    ],
    quotation.getManufacturingSize,
    {
      retry: 0,
      cacheTime: 0,
      enabled,
      onSuccess(res) {
        const resData = res?.data?.item;
        processReEstimateSizes(resData, machiningMethod);
      },
      onError(err) {
        const error = _.get(err, 'response.data');
        if (STATUS_CODE.GET_SIZES_ERROR === error?.code) {
          window.scrollTo({ top: 200, behavior: 'smooth' });
          return setEstimateErrors(
            !isProductFinished ? [t('message.E000081')] : [],
          );
        }
      },
    },
  );

  return {
    ...rest,
  };
};

export default useMultipleManufacturingSize;
